export default __webpack_public_path__ + "static/media/pic12.d8f28a30.jpg";